import React from 'react'
import cl from "../../css/Btn.module.css"
export default function Btn({ title, customStyle, ...props }) {
    return (
        <button {...props} className={cl.Btn} style={customStyle}>
        {title}
        </button>
    )
}
